import { MainMenuWrapper, MenuLink } from './Styled'

function MainMenu(): JSX.Element {
  return (
    <MainMenuWrapper>
      <MenuLink href="https://paradiso.io/" target="_blank" rel="nofollow noreferrer noopener">
        Homepage
      </MenuLink>
      <MenuLink href="https://app.paradiso.io/" target="_blank" rel="nofollow noreferrer noopener">
        Bridge
      </MenuLink>
      <MenuLink href="" target="_blank" rel="nofollow noreferrer noopener">
        Docs
      </MenuLink>
    </MainMenuWrapper>
  )
}

export default MainMenu
